module.exports = __webpack_public_path__ + "img/wx_qrcode.f21e2140.png";